var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';
import Group, { CheckboxGroupContext } from './group';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
import { isFunction } from '../_util/is';
import omit from '../_util/omit';
import useCheckbox from './useCheckbox';
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checked: !!_this.props.defaultChecked,
        };
        _this.onChange = function (e) {
            e.persist();
            e.stopPropagation();
            if (!('checked' in _this.props)) {
                _this.setState({
                    checked: e.target.checked,
                });
            }
            var _a = _this.props, onGroupChange = _a.onGroupChange, onChange = _a.onChange, isCheckboxGroup = _a.isCheckboxGroup;
            if (isCheckboxGroup && isFunction(onGroupChange)) {
                onGroupChange(_this.props.value, e.target.checked, e);
            }
            isFunction(onChange) && onChange(e.target.checked, e);
        };
        _this.renderCheckbox = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, disabled = _c.disabled, children = _c.children, className = _c.className, value = _c.value, style = _c.style, indeterminate = _c.indeterminate, error = _c.error, rest = __rest(_c, ["disabled", "children", "className", "value", "style", "indeterminate", "error"]);
            var checked = _this.state.checked;
            var prefixCls = getPrefixCls('checkbox');
            var classNames = cs(prefixCls, className, (_b = {
                    disabled: !!disabled,
                    indeterminate: !!indeterminate
                },
                _b[prefixCls + "-checked"] = checked,
                _b.error = error,
                _b));
            return (React.createElement("label", __assign({}, omit(rest, ['isCheckboxGroup', 'onGroupChange', 'onChange']), { className: classNames, style: style }),
                React.createElement("input", { value: value, disabled: !!disabled, checked: !!checked, onChange: _this.onChange, 
                    // 不加这行，放在 Select option 中，点击 Select 会触发两次 onChange。
                    onClick: function (e) { return e.stopPropagation(); }, type: "checkbox" }),
                React.createElement("span", { className: prefixCls + "-wrapper" },
                    React.createElement("div", { className: prefixCls + "-mask" }),
                    children && React.createElement("span", { className: prefixCls + "-inner-text" }, children))));
        };
        return _this;
    }
    CheckboxComponent.getDerivedStateFromProps = function (nextProps) {
        if ('checked' in nextProps) {
            return {
                checked: !!nextProps.checked,
            };
        }
        return null;
    };
    CheckboxComponent.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderCheckbox);
    };
    CheckboxComponent.__BYTE_CHECKBOX = true;
    return CheckboxComponent;
}(PureComponent));
/**
 * `T = string | number`
 */
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveRef = function (node) {
            _this.instanceRef = node;
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        var _this = this;
        return (React.createElement(CheckboxGroupContext.Consumer, null, function (value) {
            var checkboxGroupValue = value.checkboxGroupValue, rest = __rest(value, ["checkboxGroupValue"]);
            var extraProps = {};
            if (value.isCheckboxGroup) {
                extraProps = {
                    checked: checkboxGroupValue.indexOf(_this.props.value) !== -1,
                    disabled: value.disabled || _this.props.disabled,
                };
            }
            return React.createElement(CheckboxComponent, __assign({}, _this.props, rest, extraProps, { ref: _this.saveRef }));
        }));
    };
    Checkbox.displayName = 'Checkbox';
    Checkbox.Group = Group;
    Checkbox.useCheckbox = useCheckbox;
    Checkbox.propTypes = {
        style: PropTypes.object,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        defaultChecked: PropTypes.bool,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        error: PropTypes.bool,
        indeterminate: PropTypes.bool,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };
    Checkbox.defaultProps = {
        disabled: false,
        onChange: function () { },
        style: {},
        indeterminate: false,
    };
    return Checkbox;
}(Component));
export default Checkbox;
